import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation,useParams  } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const TradeChartScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { metal } = useParams();
  const [volume, setVolume] = useState(1);
  const [lot, setLot] = useState(1);
  const [tradeType, setTradeType] = useState('');
  const [uid, setUid] = useState();
  const [rate, setRate] = useState();
  const [loading, setLoading] = useState(true);
  const [high, setHigh] = useState();
  const [open, setOpen] = useState();
  const [low, setLow] = useState();
  const [target, setTarget] = useState('');
  const [stoploss, setStoploss] = useState('');
  const [limit, setLimit] = useState('');
  const [balance, setBalance] = useState();
  const [name, setName] = useState();
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  // Theme colors
  const themeColors = {
    light: {
      background: '#f8f9fa',
      cardBackground: '#fff',
      textPrimary: '#0F172A',
      textSecondary: '#334155',
      textTertiary: '#64748B',
      border: '#F1F5F9',
      primary: '#3B82F6',
      success: '#3B82F6',
      danger: '#EF4444',
      warning: '#F59E0B',
      info: '#0cba6b',
      shadow: '#000',
    },
    dark: {
      background: '#121212',
      cardBackground: '#1E1E1E',
      textPrimary: '#FFFFFF',
      textSecondary: '#E2E8F0',
      textTertiary: '#94A3B8',
      border: '#2D3748',
      primary: '#10B981',
      success: '#10B981',
      danger: '#EF4444',
      warning: '#F59E0B',
      info: '#3B82F6',
      shadow: '#000',
    }
  };

  const colors = isDarkTheme ? themeColors.dark : themeColors.light;

  // Chart data state
  const [chartData, setChartData] = useState({
    labels: ['6AM', '9AM', '12PM', '3PM', '6PM', '9PM', '12AM'],
    datasets: [{
      data: [9150, 9200, 9250, 9230, 9240, 9260, 9240],
    }],
  });

  // Fetch real-time data
  useEffect(() => {
    const interval = setInterval(() => {
      const formData = new FormData();
      formData.append('metal', metal);
      
      fetch('https://gtfundcrop.com/Rest5/metal_api/'+metal)
        .then((response) => response.json())
        .then((responseJson) => {
          setRate(responseJson.rate);
          setOpen(responseJson.open);
          setHigh(responseJson.high);
          setLow(responseJson.low);
          setLot(responseJson.lots);
          setLoading(false);
          
          // Update chart data with new rates
          setChartData(prev => ({
            ...prev,
            datasets: [{
              ...prev.datasets[0],
              data: prev.datasets[0].data.map((val, idx) => 
                idx === prev.datasets[0].data.length - 1 ? responseJson.rate : prev.datasets[0].data[idx + 1]
              ),
            }]
          }));
        }).catch((error) => {
          console.log(error);
        });
    }, 2000);

    return () => clearInterval(interval);
  }, [metal]);

  // Fetch user data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userId = localStorage.getItem("userid");
        const userName = localStorage.getItem("name");
        setName(userName);
        setUid(userId);

        const formData = new FormData();
        formData.append('user_id', userId);
        
        const response = await fetch('https://gtfundcrop.com/Rest/wallet_api', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
          },
        });
        const responseJson = await response.json();
        setBalance(responseJson.wallet);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const increaseVolume = () => {
    setVolume(prev => Number(prev) + 1);
  };

  const decreaseVolume = () => {
    if (volume > 1) {
      setVolume(prev => Number(prev) - 1);
    }
  };

  const handleSubmit = async () => { 
   
    if (volume <= 0 || volume === '') {
      alert("Please enter lot");
      return false;
    }
    
    let target1 = target;
    let stoploss1 = stoploss;
    
    if (tradeType === "BUY") {
      if (target1 === '') target1 = 100000;
      if (stoploss1 === '') stoploss1 = 0;
    } 
    if (tradeType === "SELL") {
      if (target1 === '') target1 = 0;
      if (stoploss1 === '') stoploss1 = 100000;
    }
    
    setLoading(true);
    const userid = localStorage.getItem("userid");
    
    const formData = new FormData();
    formData.append('userid', userid);
    formData.append('metal', metal);
    formData.append('lot', lot);
    formData.append('rate', rate);
    formData.append('lotsize', volume);
    formData.append('btype', tradeType);
    formData.append('market_type', "MCX");
    formData.append('target', target1);
    formData.append('stoploss', stoploss1);
    formData.append('setlimit', limit);
    formData.append('market', true);
    
    fetch('https://gtfundcrop.com/Rest5/web_trade_api/', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log(responseJson);
      alert(responseJson.msg);
      if (responseJson.status === 1) {
        navigate('/orders');
      }                
    });
  }

  if (loading) {
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: colors.background }}>
        <Spinner animation="border" variant="primary" style={{ width: 40, height: 40 }} />
        <p className="mt-3" style={{ color: colors.primary }}>Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: colors.background }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center p-3" style={{ backgroundColor: colors.background }}>
        <button 
          className="btn p-0 d-flex align-items-center justify-content-center rounded-circle"
          style={{ width: 36, height: 36, backgroundColor: 'transparent' }}
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left" style={{ fontSize: 18, color: '#3B82F6' }}></i>
        </button>
        
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center px-3 py-1 rounded-pill" style={{ backgroundColor: '#fff' }}>
            <i className="bi bi-gem me-1" style={{ fontSize: 20, color: '#3B82F6' }}></i>
            <span className="fw-semibold" style={{ fontSize: 20, color: '#3B82F6' }}>{metal}</span>
          </div>
        </div>
        
        <span className="fw-semibold" style={{ fontSize: 14, color: '#000' }}>NEW ORDER</span>
      </div>

      <div className="p-3 pb-5">
        {/* Chart Section */}
        {!tradeType && (
          <div className="rounded-3 p-3 mb-3" style={{
            backgroundColor: colors.cardBackground,
            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
            border: `1px solid ${colors.border}`
          }}>
            <div className="d-flex justify-content-between mb-3">
              <div>
                <div className="fw-bold" style={{ fontSize: 18, color: colors.textPrimary }}>{rate}</div>
                <div className="mt-1 fw-semibold" style={{ 
                  fontSize: 12, 
                  color: colors.success
                }}>
                  {open && rate ? `+${((rate - open) / open * 100).toFixed(2)}% (${(rate - open).toFixed(2)})` : 'Loading...'}
                </div>
              </div>
              <div className="d-flex align-items-center">
                <span className="small fw-medium me-1" style={{ color: colors.textTertiary }}>Today</span>
                <i className="bi bi-chevron-down" style={{ fontSize: 12, color: colors.textTertiary }}></i>
              </div>
            </div>

            {/* Chart Placeholder */}
            <div className="text-center py-4" style={{ backgroundColor: colors.cardBackground, borderRadius: 8 }}>
              <i className="bi bi-graph-up" style={{ fontSize: 48, color: colors.primary }}></i>
              <p className="mt-2 small text-secondary">Live Chart Loading...</p>
            </div>
          </div>
        )}

        {/* Time Filters */}
        <div className="d-flex gap-2 mb-3 overflow-auto pb-2" style={{ whiteSpace: 'nowrap' }}>
          {['15m', '1h', '4h', '1d', '1w', '1m', '3m', '1y'].map((item, index) => (
            <button
              key={index}
              className="btn btn-sm rounded-2 px-3 py-1 fw-medium"
              style={{
                backgroundColor: index === 3 ? colors.primary : colors.cardBackground,
                color: index === 3 ? '#fff' : colors.textSecondary,
                border: `1px solid ${index === 3 ? colors.primary : colors.border}`,
                fontSize: 11
              }}
            >
              {item}
            </button>
          ))}
        </div>

        {/* Price Details Card */}
        <div className="rounded-3 p-3 mb-3" style={{
          backgroundColor: colors.cardBackground,
          boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
          border: `1px solid ${colors.border}`
        }}>
          <div className="d-flex justify-content-between mb-3">
            <div>
              <div className="fw-bold" style={{ fontSize: 16, color: colors.textPrimary }}>{metal}</div>
              <div className="mt-1 small text-secondary">MCX</div>
            </div>
            <div className="text-end">
              <div className="fw-extrabold" style={{ fontSize: 18, color: colors.textPrimary }}>{rate}</div>
              <div className="mt-1 fw-semibold" style={{ 
                fontSize: 12, 
                color: colors.success
              }}>
                {open && rate ? `+${((rate - open) / open * 100).toFixed(2)}% (${(rate - open).toFixed(2)})` : 'Loading...'}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between pt-2" style={{ borderTop: `1px solid ${colors.border}` }}>
            <div className="text-center flex-grow-1">
              <div className="small" style={{ color: colors.textTertiary }}>High</div>
              <div className="fw-semibold mt-1" style={{ fontSize: 14, color: colors.textPrimary }}>{high}</div>
            </div>
            <div className="mx-2" style={{ width: 1, backgroundColor: colors.border }}></div>
            <div className="text-center flex-grow-1">
              <div className="small" style={{ color: colors.textTertiary }}>Low</div>
              <div className="fw-semibold mt-1" style={{ fontSize: 14, color: colors.textPrimary }}>{low}</div>
            </div>
            <div className="mx-2" style={{ width: 1, backgroundColor: colors.border }}></div>
            <div className="text-center flex-grow-1">
              <div className="small" style={{ color: colors.textTertiary }}>Open</div>
              <div className="fw-semibold mt-1" style={{ fontSize: 14, color: colors.textPrimary }}>{open}</div>
            </div>
          </div>
        </div>

        {/* Trade Form */}
        {tradeType !== '' && (
          <div className="rounded-3 p-3 mb-3" style={{
            backgroundColor: colors.cardBackground,
            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
            border: `1px solid ${colors.border}`
          }}>
            <div className="fw-bold text-center mb-3" style={{ fontSize: 16, color: colors.textPrimary }}>
              {tradeType.toUpperCase()} ORDER
            </div>

            {/* Volume Input */}
            <div className="mb-3">
              <label className="small fw-semibold mb-1 d-block" style={{ color: colors.textSecondary }}>LOT SIZE</label>
              <div className="d-flex align-items-center border rounded-2 overflow-hidden" style={{ borderColor: colors.border }}>
                <button
                  className="btn d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40, backgroundColor: isDarkTheme ? '#3D3D3D' : '#F1F1F1' }}
                  onClick={decreaseVolume}
                >
                  <span style={{ fontSize: 16, color: colors.textPrimary }}>-</span>
                </button>
                <input
                  type="number"
                  className="form-control text-center border-0"
                  style={{ flex: 1, fontSize: 14, padding: 10, color: colors.textPrimary }}
                  value={volume}
                  onChange={(e) => setVolume(e.target.value)}
                />
                <button
                  className="btn d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40, backgroundColor: colors.primary }}
                  onClick={increaseVolume}
                >
                  <span style={{ fontSize: 16, color: '#fff' }}>+</span>
                </button>
              </div>
            </div>

            {/* Target and Stop Loss */}
            <div className="row g-2 mb-3">
              <div className="col-6">
                <label className="small fw-semibold mb-1 d-block" style={{ color: colors.textSecondary }}>TARGET</label>
                <input
                  type="text"
                  className="form-control text-center"
                  style={{ fontSize: 14, padding: 10, borderColor: colors.border }}
                  value={target}
                  onChange={(e) => setTarget(e.target.value)}
                  placeholder="Enter target"
                />
              </div>
              <div className="col-6">
                <label className="small fw-semibold mb-1 d-block" style={{ color: colors.textSecondary }}>STOP LOSS</label>
                <input
                  type="text"
                  className="form-control text-center"
                  style={{ fontSize: 14, padding: 10, borderColor: colors.border }}
                  value={stoploss}
                  onChange={(e) => setStoploss(e.target.value)}
                  placeholder="Enter stop loss"
                />
              </div>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="d-flex gap-2">
          {!tradeType ? (
            <>
              <button
                className="btn flex-grow-1 py-3 fw-bold rounded-2"
                style={{
                  backgroundColor: colors.cardBackground,
                  border: `2px solid ${colors.danger}`,
                  color: colors.danger
                }}
                onClick={() => setTradeType('SELL')}
              >
                SELL
                <div className="small mt-1" style={{ color: colors.textTertiary }}>{rate}</div>
              </button>
              <button
                className="btn flex-grow-1 py-3 fw-bold rounded-2"
                style={{
                  backgroundColor: colors.primary,
                  color: '#fff'
                }}
                onClick={() => setTradeType('BUY')}
              >
                BUY
                <div className="small mt-1" style={{ color: 'rgba(255,255,255,0.8)' }}>{rate}</div>
              </button>
            </>
          ) : (
            <>
              <button
                className="btn flex-grow-1 py-3 fw-semibold rounded-2"
                style={{
                  backgroundColor: colors.cardBackground,
                  border: `1px solid ${colors.border}`,
                  color: colors.textPrimary
                }}
                onClick={() => setTradeType('')}
              >
                CANCEL
              </button>
              <button
                className="btn flex-grow-1 py-3 fw-bold rounded-2"
                style={{
                  backgroundColor: tradeType === 'BUY' ? colors.primary : colors.danger,
                  color: '#fff'
                }}
                onClick={handleSubmit}
              >
                SUBMIT {tradeType}
              </button>
            </>
          )}
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
        
        input:focus {
          outline: none;
          box-shadow: none;
          border-color: #3B82F6;
        }
        
        .btn:focus {
          outline: none;
          box-shadow: none;
        }
        
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default TradeChartScreen;